import React from "react"

import { Link } from "gatsby"

import {
  FaPhone,
  FaInstagram,
  FaFacebookSquare,
  FaLocationArrow,
} from "react-icons/fa"

import vivaldyLogo from "../../images/vivaldy-skin-clinic-logo.png"

const Footer = ({ footerData, navigation }) => {
  return (
    <React.Fragment>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-10 col-sm-10 col-md-6 col-lg-3">
              <Link to="/">
                <img
                  style={{ height: "3rem" }}
                  src={vivaldyLogo}
                  alt="Vivaldy Skin CLinic's Logo"
                />
              </Link>
              <div style={{ padding: "1rem" }} />
              <h6 className="text-muted">Connect with us</h6>
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={footerData.phone}
                  >
                    <FaPhone
                      className="brand-link"
                      style={{ fontSize: "1.5rem" }}
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={footerData.instagram}
                  >
                    <FaInstagram
                      className="brand-link"
                      style={{ fontSize: "1.5rem" }}
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={footerData.facebook}
                  >
                    <FaFacebookSquare
                      className="brand-link"
                      style={{ fontSize: "1.5rem" }}
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={footerData.location.link_to_google_maps}
                  >
                    <FaLocationArrow
                      className="brand-link"
                      style={{ fontSize: "1.5rem" }}
                    />
                  </a>
                </li>
              </ul>
              <p className="text-muted">
                <small>{footerData.location.text}</small>
              </p>
            </div>
          </div>
          <div>
            <p className="text-muted">
              <small>
                © {new Date().getFullYear().toString()} Vivaldy Skin Clinic Team
              </small>
            </p>
          </div>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer
